import type { Library, LibraryData } from '@/core/types/library.type'
import { mapLibrary } from '@/core/utils'

import type { LibraryStore } from './types'

// Re-export utils used by actions
export { getContext } from '@/core/utils'

export const mergeLibraries = (existing: Record<string, LibraryData>, libraries: Library[]) => ({
  ...existing,
  ...Object.fromEntries(
    libraries.map((lib) => {
      const mapped = mapLibrary(lib)
      return [mapped.id, mapped]
    })
  ),
})

export const appendLog = (state: LibraryStore, key: string, message: string) => ({
  ...state.logs,
  [key]: [...(state.logs[key] ?? []), message],
})
